import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import Flickity from 'flickity';
import 'jquery-parallax.js';
import 'lightgallery/dist/js/lightgallery-all';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	//mobile header nav click toggles also
	$('.navbar-header').on('click', function(event) {
    	if ($(event.target).hasClass('navbar-header') || $(event.target).hasClass('navbar-brand')) {
    		$(this).find('.navbar-toggle').trigger('click');
    	}
    });
	if ($('.m-slidebannerwrap, .slider').length) {
		var flky = new Flickity( '.m-slidebannerwrap, .slider', {
			cellAlign: 'center',
			wrapAround: true,
			imagesLoaded: true,
			autoPlay: 7000,
			pageDots: false,
			prevNextButtons: true,
			arrowShape: { 
			  x0: 10,
			  x1: 60, y1: 50,
			  x2: 65, y2: 45,
			  x3: 20
			}
		});
	}
	if ($('button.flickity-button.flickity-prev-next-button').is(":disabled")) {
		$('button.flickity-button.flickity-prev-next-button').hide();
	}

	$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

	//arrow jumpers
	$('.m-videobanner__jumparrow, .m-imagebanner__jumparrow, .m-slidebanner__jumparrow').on('click', function(event){
		var $root = $('html, body');
		var $elem = $(this);
		$root.animate({
			scrollTop: $elem.offset().top
		}, 1000);
	});

});



// WEBPACK FOOTER //
// ./src/js/main.js